module.exports = __webpack_public_path__ + "img/profile_credential_016.69d6cc48.png";